import { PageContainer } from "@/components/organisms";
import Section from "@/containers/OrderContainer/Common/Section";
import PriceInfo from "@/containers/OrderContainer/Common/PriceInfo";
import { useSelector } from 'react-redux'; // Import useSelector
import { selectCountryCode } from '@/store/slices/countryCodeSlice'; // Import selector for countryCode
import "./_orderPriceInfo.scss"
import {currencyMap} from "@/utils/constants/countryConstants";

const getCurrencyTitle = (country) => {

  return currencyMap[country]; // Default title if country is not found
};

const DisplayInformation = ({ orderDetails, country }) => {
  // Define sections and their respective data as arrays
  const sections = [
    {
      id: 'mxn',
      title: getCurrencyTitle(country), // Dynamically set the title based on the country
      data: [
        {label: 'Order Total', value: orderDetails?.orderTotal},
        {label: 'Sub Total Price', value: orderDetails?.subTotalPrice},
        {label: 'Taxable Amount', value: orderDetails?.taxableAmount},
        {label: 'Total Gift Tax Amount', value: orderDetails?.totalGiftTaxAmount},
        {label: 'Returns Total', value: orderDetails?.returnsTotal},
      ],
    },
    {
      id: 'discountsandpromotions',
      title: 'Discounts and Promotions',
      data: [
        {label: 'Contract Discount', value: orderDetails?.contractDiscount},
        {label: 'Promotional Discount', value: orderDetails?.promotionalDiscount},
        {label: 'Estimated Promotional Points', value: orderDetails?.estimatedPromotionalPoints},
        {label: 'Promotional Points', value: orderDetails?.promotionalPoints},
      ],
    },
    {
      id: 'paymentsandadjustments',
      title: 'Payments and Adjustments',
      data: [
        {label: 'Point Deducted', value: orderDetails?.pointsDeducted},
        {label: 'Total Points', value: orderDetails?.totalPoints},
        {label: 'Top Up Payment Amount', value: orderDetails?.topUpPaymentAmount},
        {label: 'Total Deposit Amount', value: orderDetails?.totalDepositAmount},
      ],
    },
    {
      id: 'invoicePriceInformation',
      title: 'Invoice Price Information',
      data: [
        {label: 'Total Gross Amount', value: orderDetails?.totalGrossAmount},
        {label: 'Total Tax Amount', value: orderDetails?.totalTaxAmount},
        {label: 'Total Discount Amount', value: orderDetails?.totalDiscountAmount},
        {label: 'Total Promotion Amount', value: orderDetails?.totalPromotionAmount},
        {label: 'Total Net Price', value: orderDetails?.totalNetPrice},
        {label: 'Points', value: orderDetails?.points},
      ],
    },
  ]

  return (
    <>
      <div className="order-overview price-info">
        {sections.map((section) => (
          <div key={section.id}>
            {/* Section Title */}
            <div className="grid pl-4">
              <Section id={section.id} title={section.title} icon={section.icon} />
            </div>

            {/* Section Data */}
            <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
              {section.data.map((item) => (
                <PriceInfo
                  label={item.label}
                  value={item.value}
                  isHighlighted={item.isHighlighted}
                  icon={item.icon}
                  key={item.label}
                />
              ))}
            </div>

          </div>
        ))}
      </div>
    </>
  );
};

const OrderPriceInfoPage = ({ OrderDetails }) => {
  const countryCode = useSelector(selectCountryCode) || localStorage.getItem("countryCode"); // Get countryCode from Redux store
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} country={countryCode} />
    </PageContainer>
  );
};

export default OrderPriceInfoPage;
